import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading2 = _resolveComponent("Heading2")!
  const _component_SkillArticle = _resolveComponent("SkillArticle")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createBlock(_component_Section, { id: "skills" }, {
    default: _withCtx(() => [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Heading2, {
            icon: "fa-solid fa-code",
            class: "mb-12"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("skills.header")), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity, index) => {
            return (_openBlock(), _createBlock(_component_SkillArticle, {
              key: entity.heading,
              class: _normalizeClass({ 'mb-12': index < _ctx.entities.length - 1 }),
              article: entity
            }, null, 8, ["class", "article"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}